import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmployerService } from 'src/app/core/services/v2/employer.service';
import { UserService } from 'src/app/core/services/v2/user.service';
import { UtilsService } from 'src/app/core/services/v2/utils.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-selected-multiple-plan',
  templateUrl: './selected-multiple-plan.component.html',
  styleUrls: ['./selected-multiple-plan.component.scss']
})
export class SelectedMultiplePlanComponent implements OnInit {
  user: any = [];

  userId: number;
  employerId: number;
  selectedPlans: any;
  planDetails: any;
  selectedEmployeeIds: any;
  activeSubscriptionId: any;
  constructor(
        private router: Router,
        private userService: UserService,
        private employerService: EmployerService,
        private loaderService: WindowLoaderService,
        private utils: UtilsService,
    
  ) {
    
   }

  ngOnInit() {
    this.getUserDetails();
    this.selectedEmployeeIds = history.state.selectedEmployeeIds || [];
    console.log("✅ Received Employee IDs:", this.selectedEmployeeIds);
    console.log("🔢 Total Employee Count:", this.selectedEmployeeIds.length);
  }
  getUserDetails() {
    // this.loaderService.show();
    this.userService.getUserDetails().subscribe(
      (userDetails) => {
        this.user = userDetails;
        // this.customerProfileId = this.user.authorizeNetUserID;

        console.log("user", this.user);
        this.userId = userDetails.id;
        this.employerId = userDetails.employerId
        console.log("This is userId: ", this.userId);
        console.log("This is employerId: ", this.employerId);
        this.getEmployerHealthSubscriptionByEmployerId();

      },
      (error) => { console.error(error); }
    );
  }
  getEmployerHealthSubscriptionByEmployerId() {
    this.loaderService.show();
    this.employerService.getEmployerHealthSubscription(this.user.employerId).subscribe(
      (res) => {
        if (res && res.resultStatus && res.resultStatus.isSuccess && Array.isArray(res.result)) {
          // Filter all active subscriptions
          const activeSubscriptions = res.result.filter(sub => sub.active);
  
          if (activeSubscriptions.length > 0) {
            this.selectedPlans = activeSubscriptions;
  
            console.log("Selected Plans:", this.selectedPlans);
          } else {
            console.warn("No active subscription found.");
            this.selectedPlans = [];
            // this.noActivePlan = true;
          }
        } else {
          console.warn("No subscription data returned.");
     
  
          const errorMessage = res.resultStatus && res.resultStatus.errorMessages
            ? res.resultStatus.errorMessages.join(", ")
            : "Failed to fetch subscription details.";
  
          this.utils.showMessageSnackBar(errorMessage, true);
        }
  
        this.loaderService.hide();
      },
      (error) => {
        console.error("Error fetching subscription details:", error);
  
        this.loaderService.hide();
  
        this.utils.showMessageSnackBar("An error occurred while fetching employer health subscription.", true);
      }
    );
  }
  // handleSubscription(plan: any) {
  //   this.planDetails =plan.subscriptionType.name
  //   console.log("Clicked Subscription:", plan);
  //   this.router.navigate(["/employer/addempCheckout"], { 
  //     state: { planDetails: this.planDetails } 
  //   });
  // }
  handleSubscription(plan: any) {
    this.planDetails = plan.subscriptionType.name;
    this.activeSubscriptionId = plan.subscriptionTypeId
    console.log("Clicked Subscription:", plan);
    console.log("Passing Employee IDs:", this.selectedEmployeeIds);
  
    this.router.navigate(["/employer/activeProgram"], { 
      state: { 
        planDetails: this.planDetails,
        selectedEmployeeIds: this.selectedEmployeeIds,
        activeSubscriptionId: this.activeSubscriptionId
      }
    });
  }
  
}
